'use strict';
import util from '../util';
import recaptcha from '../recaptcha';

function initContactUs() {
    var $contactUsForm = $('#contact-us-form');

    $('.send-contact-us button').on('click', function() {
		$('.contact-comment textarea').focusout();
	});

    $contactUsForm.on('click', '#sendBtn', function (e) {
        e.preventDefault();
        if (recaptcha.getGoogleRecaptchaEnableStatus(recaptcha.source.CONTACT_US)) {
        	recaptcha.generateRecaptchaToken(e, recaptcha.source.CONTACT_US, submitContactUsForm);
        } else {
            submitContactUsForm();
        }
    });
}

function submitContactUsForm (token) {
    var $contactUsForm = $('#contact-us-form');
    let $sfscForm = $('#contact-us-sfsc-form');
    $sfscForm.find('[data-contactus-field-id=dwfrm_contactus_firstname]').val($contactUsForm.find('#dwfrm_contactus_firstname').val());
    $sfscForm.find('[data-contactus-field-id=dwfrm_contactus_lastname]').val($contactUsForm.find('#dwfrm_contactus_lastname').val());
    $sfscForm.find('[data-contactus-field-id=dwfrm_contactus_email]').val($contactUsForm.find('#dwfrm_contactus_email').val());
    $sfscForm.find('[data-contactus-field-id=dwfrm_contactus_phone]').val($contactUsForm.find('#dwfrm_contactus_phone').val());
    $sfscForm.find('[data-contactus-field-id=dwfrm_contactus_country]').val($contactUsForm.find('#dwfrm_contactus_country').children("option:selected").val());
    $sfscForm.find('[data-contactus-field-id=dwfrm_contactus_myquestion]').val($contactUsForm.find('#dwfrm_contactus_myquestion').children("option:selected").val());
    $sfscForm.find('[data-contactus-field-id=dwfrm_contactus_comment]').val($contactUsForm.find('#dwfrm_contactus_comment').val());

	var submitURL = Urls.customerServiceSubmit;
	if (recaptcha.getGoogleRecaptchaEnableStatus(recaptcha.source.CONTACT_US) && token) {
		submitURL = util.appendParamToURL(Urls.customerServiceSubmit, 'captchaToken', token);
	}
    
    $contactUsForm.find(".dialog-required").hide();

	$.ajax({
        url: util.appendParamToURL(submitURL, 'format', 'ajax'),
        data: $('#contact-us-form').serialize(),
        method: 'POST'
    }).done(function (response) {
        if (response.status) {
            $sfscForm.find('[type=submit]').trigger('click');
        } else {
        	clearContactUsForm(response.status);
        }
    });
}

/**
 * Clear contact us form
 */
function clearContactUsForm(status) {

	if (status == false) {
		$('.error-form.gicErrorMessage').removeClass('hide');
		return;
	}

	$('.error-form.gicErrorMessage').addClass('hide');

	if (status) {
	    $('input[name$="_contactus_firstname"]').val('');
	    $('input[name$="_contactus_lastname"]').val('');
	    $('input[name$="_contactus_email"]').val('');
	    $('input[name$="_contactus_phone"]').val('');
	    $('textarea[name$="_contactus_comment"]').val('');
    }
}

export default { initContactUs };
